import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "bar-chart-container" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BarChart = _resolveComponent("BarChart")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_BarChart, {
      "chart-data": _ctx.chartData,
      options: _ctx.state.option,
      style: { width: '100%', height: '320px' }
    }, null, 8, ["chart-data", "options"])
  ]))
}